import { Dispatch } from 'redux';
import BrazeController from '../controllers/BrazeController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class BrazeCRUDActions extends CrudActionContainer {
  retrievedAccessToken: string;
  retrieveAccounts: string;
  retrieveSegments: string;
  resetStore: string;

  constructor() {
    super('BRAZE');
    this.retrieveAccounts = this.makeActionKey('RETRIEVED_ACCOUNTS');
    this.retrieveSegments = this.makeActionKey('RETRIEVED_SEGMENTS');
    this.retrievedAccessToken = this.makeActionKey('RETRIVED_ACCESS_TOKEN');
    this.resetStore = this.makeActionKey('RESET_STORE');
  }

  getAccounts(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAccounts));
      try {
        const response = await BrazeController.getAccounts(facebookPageId);
        dispatch({
          type: this.retrieveAccounts,
          accounts: response,
        });
        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  getSegments(
    facebookPageId: number,
    accessTokenId: number,
    force: boolean = false,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveSegments));
      try {
        const response = await BrazeController.getSegments(
          facebookPageId,
          accessTokenId,
          force,
        );
        dispatch({
          type: this.retrieveSegments,
          segments: response,
        });
        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  createAccessToken(
    facebookPageId: number,
    acceesToken: string,
    instanceUrl: string,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.createAction));

        const res = await BrazeController.createAccessToken(
          facebookPageId,
          acceesToken,
          instanceUrl,
        );
        dispatch({ type: this.retrievedAccessToken, account: res });
        return res;
      } catch (error) {
        commonHandler(dispatch)(error);
        return false;
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  updateAcceessToken(
    facebookPageId: number,
    id: number,
    acceesToken?: string,
    instanceUrl?: string,
    segmentId?: string,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.createAction));

        const res = await BrazeController.updateAccessToken(
          facebookPageId,
          id,
          acceesToken,
          instanceUrl,
          segmentId,
        );

        dispatch({ type: this.retrievedAccessToken, account: res });
        return res;
      } catch (error) {
        commonHandler(dispatch)(error);
        return false;
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  invalidateStore() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch({ type: this.resetStore });
    };
  }
}

const brazeCRUDActions = new BrazeCRUDActions();

export default brazeCRUDActions;

export const useBrazeCRUDActions = getActionHookBuilder(brazeCRUDActions, [
  'getAccounts',
  'getSegments',
  'invalidateStore',
  'createAccessToken',
  'updateAcceessToken',
]);
